import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SiteLayout from "@/components/layout/SiteLayout";
import HairRemovalPage from "@/pages/treatment/hair-removal/page";
import SlimZeroPage from "@/pages/treatment/slim-zero/page";
import SkinManagementPage from "@/pages/treatment/skin-management/page";
import SkinTreatmentPage from "@/pages/skin/page";
import SubTreatmentPage from "@/pages/treatment/detail/page";
import RegenerativePage from "@/pages/treatment/regenerative/page";
import InjectablesPage from "@/pages/treatment/injectables/page";
import EyePage from "@/pages/treatment/eye/page";
import PricePage from "@/pages/price/page";
import PrivacyPolicyPage from "@/pages/legal/privacy/page";
import MinorConsentPage from "@/pages/legal/minor-consent/page";
import MedicalAdvertisingPage from "@/pages/legal/medical-advertising/page";
import RecruitPage from "@/pages/legal/recruit/page";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/treatment/hair-removal",
        element: <HairRemovalPage />,
      },
      {
        path: "/treatment/slim-zero",
        element: <SlimZeroPage />,
      },
      {
        path: "/treatment/skin-management",
        element: <SkinManagementPage />,
      },
      {
        path: "/treatment/regenerative",
        element: <RegenerativePage />,
      },
      {
        path: "/treatment/injectables",
        element: <InjectablesPage />,
      },
      {
        path: "/treatment/eye",
        element: <EyePage />,
      },
      {
        path: "/skin/:slug",
        element: <SkinTreatmentPage />,
      },
      {
        path: "/skin/photo-rf",
        element: <Navigate to="/skin/white-photo-facial" replace />,
      },
      // 旧URLからのリダイレクト（旧slugは新メニューとして表示しない）
      {
        path: "/skin/venus-filorga",
        element: <Navigate to="/skin/venus-stemsup" replace />,
      },
      {
        path: "/skin/hyper-filorga",
        element: <Navigate to="/skin/cinderella-stemsup" replace />,
      },
      {
        path: "/skin/hyper-diamond",
        element: <Navigate to="/skin/cinderella-diamond" replace />,
      },
      {
        path: "/slim/:slug",
        element: <SubTreatmentPage category="slim" />,
      },
      // 旧URLからのリダイレクト（旧再生医療 中心施術はStemSup点滴へ）
      {
        path: "/regenerative/dermapen-stemsup",
        element: <Navigate to="/regenerative/stemsup-drip" replace />,
      },
      {
        path: "/regenerative/:slug",
        element: <SubTreatmentPage category="regenerative" />,
      },
      {
        path: "/injectables/:slug",
        element: <SubTreatmentPage category="injectables" />,
      },
      {
        path: "/eye/:slug",
        element: <SubTreatmentPage category="eye" />,
      },
      {
        path: "/price",
        element: <PricePage />,
      },
      {
        path: "/privacy",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "/minor-consent",
        element: <MinorConsentPage />,
      },
      {
        path: "/medical-advertising",
        element: <MedicalAdvertisingPage />,
      },
      {
        path: "/recruit",
        element: <RecruitPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;